const YOUTUBE_IFRAME_REGEX =
  /<iframe\b[^>]*\bsrc=(["'])https?:\/\/(?:www\.)?youtube\.com\/embed\/([a-zA-Z0-9_-]+)(?:\?[^"']*)?\1[^>]*?(?:\btitle=(["'])(.*?)\3[^>]*)?>[\s\S]*?<\/iframe>/gi;

const getYouTubeWatchUrl = (videoId: string) =>
  `https://www.youtube.com/watch?v=${videoId}`;

const getYouTubeThumbnailUrl = (videoId: string) =>
  `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

const escapeHtmlText = (value: string) =>
  value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

const escapeHtmlAttribute = (value: string) =>
  escapeHtmlText(value).replace(/"/g, '&quot;').replace(/'/g, '&#39;');

const buildYouTubeThumbnailLink = (videoId: string, title: string) => {
  const safeTitle = title.trim() || 'YouTube 영상';
  const textTitle = escapeHtmlText(safeTitle);
  const attributeTitle = escapeHtmlAttribute(safeTitle);
  const watchUrl = getYouTubeWatchUrl(videoId);
  const thumbnailUrl = getYouTubeThumbnailUrl(videoId);

  return `<a href="${watchUrl}" target="_blank" rel="noopener noreferrer" data-youtube-thumbnail="true" data-youtube-video-id="${videoId}" data-youtube-title="${attributeTitle}" style="display:block;max-width:100%;overflow:hidden;border-radius:8px;border:1px solid #e5e7eb;background:#000;text-decoration:none;"><img src="${thumbnailUrl}" alt="${attributeTitle}" style="display:block;width:100%;aspect-ratio:16/9;object-fit:cover;" /><strong style="display:block;padding:8px 10px;background:#fff;color:#374151;font-size:12px;">${textTitle}</strong></a>`;
};

export const normalizeYouTubeIframesToThumbnails = (htmlText: string) => {
  return htmlText.replace(
    YOUTUBE_IFRAME_REGEX,
    (_match, _srcQuote: string, videoId: string, _titleQuote = '', title = '') =>
      buildYouTubeThumbnailLink(videoId, title)
  );
};
